import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=5811d9ee&"
import script from "./Avatar.vue?vue&type=script&lang=ts&"
export * from "./Avatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5811d9ee')) {
      api.createRecord('5811d9ee', component.options)
    } else {
      api.reload('5811d9ee', component.options)
    }
    module.hot.accept("./Avatar.vue?vue&type=template&id=5811d9ee&", function () {
      api.rerender('5811d9ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Avatar.vue"
export default component.exports